import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94d6e3f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "table" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "handler" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("按钮位置")
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "handlerBtn", {}, () => [
            _hoisted_5
          ], true)
        ])
      ], true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_table, _mergeProps({
        data: _ctx.listData,
        border: "",
        style: {"width":"100%"},
        onSelectionChange: _ctx.selectionChange
      }, _ctx.childrenProps), {
        default: _withCtx(() => [
          (_ctx.showSelectColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "60",
                align: "center"
              }))
            : _createCommentVNode("", true),
          (_ctx.showIndexColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                type: "index",
                label: "序号",
                width: "80",
                align: "center"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propList, (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              key: item.prop
            }, item, {
              align: "center",
              "show-overflow-tooltip": ""
            }), {
              default: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, item.slotName, {
                  row: scope.row
                }, () => [
                  _createTextVNode(_toDisplayString(scope.row[item.prop]), 1)
                ], true)
              ]),
              _: 2
            }, 1040))
          }), 128))
        ]),
        _: 3
      }, 16, ["data", "onSelectionChange"])
    ]),
    (_ctx.showFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createVNode(_component_el_pagination, {
              currentPage: _ctx.page.currentPage,
              "page-size": _ctx.page.size,
              "page-sizes": [1, 5, 10],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.listCount,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ], true)
        ]))
      : _createCommentVNode("", true)
  ]))
}